module.exports = __webpack_public_path__ + "static/media/ic_save.f91f55d5.svg";